import './css/RoomStatus.css'

import { useEffect, useMemo, useState } from "react"
import { Link } from "react-router-dom"
import { Input, Button, Space, Select, DatePicker, message, } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosNoInfo } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import moment from "moment"
import _ from 'lodash'

const { Option } = Select

type fetchParams = {
    store_id: undefined | string,
    date: any,
    check_in_user_name: string | undefined,
    check_in_phone: string | undefined,
    room_type_id: string | undefined,
    room_number: string | undefined,
    floor: number | undefined,
    direction: number | undefined,
    minion_id: string | undefined
}

interface ep {
    "employee_id": string,
    "user_name": string
}

interface room {
    "room_id": string // 房间id
    "room_number": string // 房间号
    "room_type_id": string // 房型id
    "room_type_name": string // 房型名称
    "room_status": number // 房间状态
    "can_reserve_days": number
    "check_in_id": string
    "check_in_user_name": string
    "check_in_start_day": string
    "check_in_end_day": string
    "check_in_total_days": number
    "check_in_already_days": number
    "check_in_left_days": number
    "belong_minion_id": string
    "belong_minion_name": string
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        date: null,
        check_in_user_name: undefined,
        check_in_phone: undefined,
        room_type_id: undefined,
        room_number: undefined,
        floor: undefined,
        direction: undefined,
        minion_id: undefined
    }

    const [roomTypeList, setRoomTypeList] = useState<{ room_type_id: string, room_type_name: string }[]>([])
    const [roomWays, setRoomWays] = useState<{ direction: string | number, direction_name: any }[]>([])
    const [gjData, setGjData] = useState<ep[]>([])

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)

    const [data, setData] = useState<any>([])
    const [numData, setNumData] = useState<{
        empty_room_count: number, // 空房数
        reserve_room_count: number, // 已预订房间数
        check_in_room_count: number, // 入住房间数
        leave_room_count: number // 出所房间数
        total_room_count: number // 房间总数
        total_empty_room_count: number // 空房间数
        total_check_in_room_count: number // 入住房间数
        total_check_in_per: string, // 入住率，字符串类型，例如"30%"
        total_reserve_room_count: number
        room_count: number
        check_in_per: string
    }>({
        empty_room_count: 0,
        reserve_room_count: 0,
        check_in_room_count: 0,
        leave_room_count: 0,
        total_room_count: 0,
        total_empty_room_count: 0,
        total_check_in_room_count: 0,
        total_check_in_per: '0%',
        total_reserve_room_count: 0,
        room_count: 0,
        check_in_per: ''
    })

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        fetch({ fetchOtherParams })
    }, [])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        fetch({ fetchOtherParams })
    }

    const fetch = ({ fetchOtherParams }: { fetchOtherParams: object }) => {

        let params: any = { ...fetchOtherParams }

        if (params.date) {
            params.date = moment(params.date).format('YYYY-MM-DD')
        }

        axiosTable.get('/keeper/check_in/room_situation', {
            params: {
                ...params
            }

        }).then((response: any) => {
            if (response.room_list) {
                setData(filterData(response.room_list))

                if (response.length === 0) {
                    message.info('暂无房间数据')
                }
            }

            setNumData({
                empty_room_count: response.empty_room_count,
                reserve_room_count: response.reserve_room_count,
                check_in_room_count: response.check_in_room_count,
                leave_room_count: response.leave_room_count,
                total_room_count: response.total_room_count,
                total_empty_room_count: response.total_empty_room_count,
                total_check_in_room_count: response.total_check_in_room_count,
                total_check_in_per: response.total_check_in_per,
                total_reserve_room_count: response.total_reserve_room_count,
                room_count: response.room_count,
                check_in_per: response.check_in_per
            })
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)
    }

    const filterData = (orginData: room[]) => {
        let typeNames: any = new Set(orginData.map(el => el.room_type_name))
        typeNames = [...typeNames]

        let arr: any[] = []
        typeNames.forEach((el: any, index: number) => {
            arr[index] = {
                typeName: '',
                roomList: []
            }

            arr[index].typeName = el

            orginData.forEach(el2 => {
                if (el2.room_type_name === el) {
                    arr[index].roomList.push(el2)
                }
            })
        })

        return arr
    }

    return (<div className="common-page">
        {/* 管家中心 -> 入住管理 -> 房态图 */}
        <BreadCrumb position={['管家中心', '房态图']} />

        <div className="common-top-form">
            <div className="clear" style={{ marginBottom: 28, fontSize: 16 }}>
                <div className="fl" style={{ marginRight: 10, fontWeight: 'bold' }}>
                    集团数据
                </div>

                <div className="fl" style={{ marginRight: 20 }}>
                    【房间总数：{numData.total_room_count}、
                    空房间总数：{numData.total_empty_room_count}、
                    预定房间总数：{numData.total_reserve_room_count}、
                    入住房间总数：{numData.total_check_in_room_count}、
                    入住率：{numData.total_check_in_per}】
                </div>
            </div>

            {/* 筛选条件 */}
            <Space direction="horizontal" wrap>
                <div className="fl" style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores value={fetchOtherParams.store_id} onChange={(v: string) => {
                        handleChange(v, 'store_id')

                        baseAxiosNoInfo('/global/employee_list_by_position', {
                            params: {
                                department_id: v,
                                position_number: '22,26'
                            }
                        }).then((res: any) => {
                            res && setGjData(res)
                        })

                        if (v) {
                            // 查询房型
                            baseAxiosNoInfo('/global/room_type_list_by_store', {
                                params: {
                                    store_id: v
                                }
                            }).then((res: any) => {
                                res && setRoomTypeList(res)
                            })

                            // 查询朝向
                            baseAxiosNoInfo('/global/room_direction_list_by_store', {
                                params: {
                                    store_id: v
                                }
                            }).then((res: any) => {
                                res && setRoomWays(res)
                            })

                        } else {
                            setRoomTypeList([])
                            setRoomWays([])
                        }
                    }} />
                </div>

                <DatePicker className="fl" style={{ marginRight: 8, marginBottom: 12, width: 120 }} value={fetchOtherParams.date} onChange={(v: any) => {
                    handleChange(v, 'date')
                }} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="入住人姓名" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_user_name') }} value={fetchOtherParams.check_in_user_name} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="入住人手机号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_phone') }} value={fetchOtherParams.check_in_phone} />
                {/* 房间房型 */}
                <Select virtual={false} className="fl" style={{ marginRight: 8, marginBottom: 12, width: 140 }} placeholder="房型" onChange={(e: string) => { handleChange(e, 'room_type_id') }} value={fetchOtherParams.room_type_id} >
                    {roomTypeList.map((el: { room_type_id: string, room_type_name: string }) => <Option key={el.room_type_id} value={el.room_type_id}>{el.room_type_name}</Option>)}
                </Select>
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="房号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'room_number') }} value={fetchOtherParams.room_number} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="楼层" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'floor') }} value={fetchOtherParams.floor} />
                {/* 房间朝向 */}
                {/* <Select virtual={false} className="fl" style={{ width: 140, marginRight: 12 }} placeholder="朝向" onChange={(e: number) => { handleChange(e, 'direction') }} value={fetchOtherParams.direction}  >
                    {roomWays.map((el: any) => <Option key={el.direction} value={el.direction}>{el.direction_name}</Option>)}
                </Select> */}
                <Select virtual={false} className="fl" style={{ marginRight: 8, marginBottom: 12, width: 140 }} placeholder="责任管家" onChange={(e: string) => { handleChange(e, 'minion_id') }} value={fetchOtherParams.minion_id}>
                    {gjData.map((el: ep) => <Option value={el.employee_id} key={el.employee_id}>{el.user_name}</Option>)}
                </Select>
            </Space>

            <div style={{ marginTop: 6 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
            </div>
        </div>

        <div className="common-main">
            <div className="clear" style={{ paddingBottom: 16 }}>
                <div className="fl" style={{ marginRight: 10, fontWeight: 'bold' }}>
                    <span>门店数据</span>
                </div>
                <div className="fl">
                    <Space>
                        <div className="secs" style={{ width: 20, height: 20, background: '#fff', border: '1px solid #999' }}></div>
                        <span>房间总数（{numData.room_count}）</span>
                    </Space>
                    <Space>
                        <div className="secs" style={{ width: 20, height: 20, background: '#fff', border: '1px solid #999' }}></div>
                        <span>空房（{numData.empty_room_count}）</span>
                    </Space>
                    <Space style={{ marginLeft: 16 }}>
                        <div className="secs" style={{ width: 20, height: 20, background: '#1890ff' }}></div>
                        <span>已预订（{numData.reserve_room_count}）</span>
                    </Space>
                    <Space style={{ marginLeft: 16 }}>
                        <div className="secs" style={{ width: 20, height: 20, background: '#ff4d4f' }}></div>
                        <span>已入住（{numData.check_in_room_count}）</span>
                    </Space>
                    <Space style={{ marginLeft: 16 }}>
                        <div className="secs" style={{ width: 20, height: 20, background: '#52c41a' }}></div>
                        <span>已出所（{numData.leave_room_count}）</span>
                    </Space>
                    <Space style={{ marginLeft: 16 }}>
                        <div className="secs" style={{ width: 20, height: 20, background: '#52c41a' }}></div>
                        <span>入住率（{numData.check_in_per}）</span>
                    </Space>
                </div>
            </div>

            {data.length === 0 && <p style={{ textAlign: 'center', fontSize: 16 }}>需要先选择门店后进行查询数据</p>}

            {data.map((el: any) => <div>
                <h3 className="room-title">{el.typeName}</h3>

                <ul className="room-list clear">
                    {el.roomList.map((el2: any) => {
                        if (el2.room_status === 4) {
                            return <li className="empty">
                                <p className="room-number">{el2.room_number}</p>
                                {el2.can_reserve_days > 0 && <p className="can-reserve-days">可预订天数：{el2.can_reserve_days}</p>}
                            </li>
                        }

                        if (el2.room_status === 1) {
                            return <li className="yd">
                                <Link to={'/check_in_detail/' + el2.check_in_id}>
                                    <p className="room-number">{el2.room_number}</p>

                                    <div className="room-infos">
                                        <p>{el2.check_in_user_name}</p>
                                        <p>管家：{el2.belong_minion_name}</p>
                                        <p>{el2.check_in_start_day}-{el2.check_in_end_day}</p>
                                    </div>

                                    <div className="nums">
                                        <p>共{el2.check_in_total_days}</p>
                                        <p>住{el2.check_in_already_days}</p>
                                        <p>剩{el2.check_in_left_days}</p>
                                    </div>
                                </Link>
                            </li>
                        }

                        if (el2.room_status === 2) {
                            return <li className="in">
                                <Link to={'/check_in_detail/' + el2.check_in_id}>
                                    <p className="room-number">{el2.room_number}</p>

                                    <div className="room-infos">
                                        <p>{el2.check_in_user_name}</p>
                                        <p>管家：{el2.belong_minion_name}</p>
                                        <p>{el2.check_in_start_day}-{el2.check_in_end_day}</p>
                                    </div>

                                    <div className="nums">
                                        <p>共{el2.check_in_total_days}</p>
                                        <p>住{el2.check_in_already_days}</p>
                                        <p>剩{el2.check_in_left_days}</p>
                                    </div>
                                </Link>
                            </li>
                        }

                        if (el2.room_status === 3) {
                            return <li className="out">
                                <Link to={'/check_in_detail/' + el2.check_in_id}>
                                    <p className="room-number">{el2.room_number}</p>

                                    <div className="room-infos">
                                        <p>{el2.check_in_user_name}</p>
                                        <p>管家：{el2.belong_minion_name}</p>
                                        <p>{el2.check_in_start_day}-{el2.check_in_end_day}</p>
                                    </div>

                                    <div className="nums">
                                        <p>共{el2.check_in_total_days}</p>
                                        <p>住{el2.check_in_already_days}</p>
                                        <p>剩{el2.check_in_left_days}</p>
                                    </div>
                                </Link>
                            </li>
                        }
                    })}
                </ul>
            </div>)}
        </div>
    </div>)
}